export default __webpack_public_path__ + "static/media/up_arrow.68d7a446.svg";